import { Mui, usePrevious } from "@osu/react-ui";
import React, { Fragment, useEffect, useState } from "react";

function TextInput(props = {}) {
  const { id, value, className, required, onChange, title, defaultValue, type, error: formError, skType, dataField, gridProps, filterState, description, getStudentInfo, inputProps = {}, ...rest } = props;
  const maxLength = (inputProps?.maxLength ?? 150);
  if(!inputProps.maxLength) inputProps.maxLength = maxLength;
  const descriptionProps = Object.assign({ className: null, component: "div", top: false, variant: "body2" }, (rest.descriptionProps ?? {}));

  const [shrink, setShrink] = useState(!!value)
  const previousDefaultValue = usePrevious(defaultValue)
  const [error, setError] = useState(formError)

  const onBlur = () => {
    if(type === "tel" && value) {
      const phoneLength = value.match(/(\d)/g).length
      setError(phoneLength === 10 
        ? ""
        : "Please enter a valid 10 digit phone number."
        )
    }
    setShrink(!!value)
  }

  useEffect(() => {
    if(onChange && !previousDefaultValue && !value && defaultValue) {
      onChange({
        id,
        value: defaultValue
      });
    }
  }, [defaultValue, id, onChange, previousDefaultValue, value])

  useEffect(() => {
    setError(err => {
      if(err !== formError) {
          return formError
       }
      return err
    });
  }, [formError]);

  const descriptionClassName = (descriptionProps.top === true ? `margin-bottom-1 ${descriptionProps.className}` : `margin-top-1 ${descriptionProps.className}`);
  const Description = (<Mui.Typography className={descriptionClassName} component={descriptionProps.component} variant={descriptionProps.variant}>{description}</Mui.Typography>);

  return <Mui.FormControl className={className} fullWidth={true}>
    {(description && descriptionProps.top === true) && Description}
    <Mui.TextField
      id={id}
      value={value ?? ""}
      required={required}
      error={!!error}
      onFocus={() => {
        setShrink(true)
      }}
      onBlur={onBlur}
      onChange={(e) => {
        let value = e.target.value;
        if(value && value?.length > maxLength) value = value.substring(0, maxLength);
        onChange({ id, value });
      }}
      label={title}
      type={type}
      InputLabelProps={{ shrink: !!value || shrink }}
      inputProps={inputProps}
      {...rest}
      helperText={error}
    />
    {(description && descriptionProps.top === false) && Description}
  </Mui.FormControl>;
}

TextInput.defaultProps = {
  variant: "outlined",
  value: ""
};

export default TextInput;
